import { store } from "../lib/storage";
import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { LANGS, STRINGS } from "../lib/strings";

const legacy = {
  en: { brand: "ULUME", marketplace: "Marketplace", farmers: "Farmers", ai: "AI Tools",
        dashboard: "Dashboard", login: "Login", signup: "Get Started", logout: "Sign Out",
        cart: "Cart", wishlist: "Wishlist", chat: "Messages",
        hero_title: "Rooted in soil, grown for India", hero_sub: "ULUME unites farmers, buyers, and vendors on one trusted marketplace — from seed to harvest to plate.",
        cta_browse: "Browse Marketplace", cta_join: "Join as Farmer",
        agri_inputs: "Agri-Inputs E-commerce", produce: "Farmer Produce", search: "Search",
        all_categories: "All Categories", add_to_cart: "Add to Cart", buy_now: "Buy Now",
        contact_farmer: "Contact Farmer", procure: "Send Procurement Request",
  },
  hi: { brand: "ULUME", marketplace: "बाज़ार", farmers: "किसान", ai: "AI उपकरण",
        dashboard: "डैशबोर्ड", login: "लॉगिन", signup: "शुरू करें", logout: "साइन आउट",
        cart: "कार्ट", wishlist: "विशलिस्ट", chat: "संदेश",
        hero_title: "मिट्टी में जड़ें, भारत के लिए उगाया", hero_sub: "ULUME किसानों, खरीदारों और विक्रेताओं को एक भरोसेमंद बाजार पर एकजुट करता है।",
        cta_browse: "बाज़ार देखें", cta_join: "किसान के रूप में जुड़ें",
        agri_inputs: "कृषि सामग्री ई-कॉमर्स", produce: "किसान उत्पाद", search: "खोजें",
        all_categories: "सभी श्रेणियाँ", add_to_cart: "कार्ट में जोड़ें", buy_now: "अभी खरीदें",
        contact_farmer: "किसान से संपर्क करें", procure: "खरीद अनुरोध भेजें",
  },
  kn: { brand: "ULUME", marketplace: "ಮಾರುಕಟ್ಟೆ", farmers: "ರೈತರು", ai: "AI ಉಪಕರಣಗಳು",
        dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್", login: "ಲಾಗಿನ್", signup: "ಪ್ರಾರಂಭಿಸಿ", logout: "ಸೈನ್ ಔಟ್",
        cart: "ಕಾರ್ಟ್", wishlist: "ಇಷ್ಟಪಟ್ಟಿ", chat: "ಸಂದೇಶಗಳು",
        hero_title: "ಮಣ್ಣಿನಲ್ಲಿ ಬೇರೂರಿ, ಭಾರತಕ್ಕಾಗಿ ಬೆಳೆದ", hero_sub: "ULUME ರೈತರು, ಖರೀದಿದಾರರು ಮತ್ತು ಮಾರಾಟಗಾರರನ್ನು ಒಂದು ವಿಶ್ವಾಸಾರ್ಹ ಮಾರುಕಟ್ಟೆಯಲ್ಲಿ ಒಂದುಗೂಡಿಸುತ್ತದೆ.",
        cta_browse: "ಮಾರುಕಟ್ಟೆ ನೋಡಿ", cta_join: "ರೈತರಾಗಿ ಸೇರಿ",
        agri_inputs: "ಕೃಷಿ ಸಾಮಗ್ರಿಗಳು", produce: "ರೈತರ ಉತ್ಪನ್ನ", search: "ಹುಡುಕಿ",
        all_categories: "ಎಲ್ಲಾ ವರ್ಗಗಳು", add_to_cart: "ಕಾರ್ಟ್‌ಗೆ ಸೇರಿಸಿ", buy_now: "ಈಗ ಖರೀದಿಸಿ",
        contact_farmer: "ರೈತರನ್ನು ಸಂಪರ್ಕಿಸಿ", procure: "ಖರೀದಿ ವಿನಂತಿ ಕಳುಹಿಸಿ",
  },
  te: { brand: "ULUME", marketplace: "మార్కెట్", farmers: "రైతులు", ai: "AI సాధనాలు",
        dashboard: "డాష్‌బోర్డ్", login: "లాగిన్", signup: "ప్రారంభించండి", logout: "సైన్ అవుట్",
        cart: "కార్ట్", wishlist: "ఇష్టాల జాబితా", chat: "సందేశాలు",
        hero_title: "మట్టిలో పాతుకుపోయి, భారత్ కోసం పెరిగిన", hero_sub: "ULUME రైతులు, కొనుగోలుదారులు మరియు విక్రేతలను ఒకే నమ్మకమైన మార్కెట్‌లో ఏకం చేస్తుంది.",
        cta_browse: "మార్కెట్ చూడండి", cta_join: "రైతుగా చేరండి",
        agri_inputs: "వ్యవసాయ సామగ్రి", produce: "రైతు ఉత్పత్తులు", search: "శోధించండి",
        all_categories: "అన్ని వర్గాలు", add_to_cart: "కార్ట్‌లో జోడించండి", buy_now: "ఇప్పుడు కొనండి",
        contact_farmer: "రైతును సంప్రదించండి", procure: "కొనుగోలు అభ్యర్థన పంపండి",
  },
  ta: { brand: "ULUME", marketplace: "சந்தை", farmers: "விவசாயிகள்", ai: "AI கருவிகள்",
        dashboard: "டாஷ்போர்டு", login: "உள்நுழைய", signup: "தொடங்குங்கள்", logout: "வெளியேறு",
        cart: "கூடை", wishlist: "விருப்பப்பட்டியல்", chat: "செய்திகள்",
        hero_title: "மண்ணில் வேரூன்றி, இந்தியாவுக்காக வளர்ந்த", hero_sub: "ULUME விவசாயிகள், வாங்குபவர்கள் மற்றும் விற்பனையாளர்களை ஒரு நம்பகமான சந்தையில் இணைக்கிறது.",
        cta_browse: "சந்தையை பார்க்க", cta_join: "விவசாயியாக சேர",
        agri_inputs: "விவசாய பொருட்கள்", produce: "விவசாயி உற்பத்தி", search: "தேடு",
        all_categories: "அனைத்து வகைகள்", add_to_cart: "கூடையில் சேர்", buy_now: "இப்போது வாங்க",
        contact_farmer: "விவசாயியை தொடர்பு கொள்ள", procure: "கொள்முதல் கோரிக்கை அனுப்பு",
  },
};

// Merge the larger STRINGS table (key -> [en, hi, kn, te, ta]) over the legacy keys.
const translations = Object.fromEntries(LANGS.map((l) => [l, { ...legacy[l] }]));
Object.entries(STRINGS).forEach(([key, arr]) => {
  LANGS.forEach((l, i) => { if (arr[i]) translations[l][key] = arr[i]; });
});

const fill = (str, vars) =>
  vars ? str.replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined ? vars[k] : m)) : str;

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(store.get("ulume_lang") || "en");
  const change = useCallback((l) => { setLang(l); store.set("ulume_lang", l); }, []);
  const t = useCallback((key, vars) => fill(translations[lang]?.[key] ?? translations.en[key] ?? key, vars), [lang]);
  const value = useMemo(() => ({ lang, change, t }), [lang, change, t]);
  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
